import React from "react";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import SectionHeading from "../SectionHeading";

import MessageList from "../MessageList";
import NotificationListDashboard from "../MessageList/NotificationListDashboard";
import { useDispatch, useSelector } from "react-redux";
const AlertNotification = ({ t }) => {
 
  const {
    auth: { profile },
    dashboardInfo: { myActiveDonationsOffSet, myActiveDonationsLimit, entityProfileSelect },
  } = useSelector((state) => state);

  return (
    <>
      <SectionHeading
        heading=""
        subHeading="myAlertsSub"
        t={t}
        style={{
          marginTop: "10px",
          marginBottom: "41px",
        }}
      />

      <Paper sx={{ padding: "20px"  }}>
        <Typography fontSize={"16px"} fontWeight={"medium"}>
          {t("messageAndNotification")}
        </Typography>
        <Divider />
        <MessageList t={t} />
      </Paper>
      <br></br>
      {(profile.entity.entityType == 'DONOR' || entityProfileSelect == 'DONOR') && 
       <Paper sx={{ padding: "20px" }}>
       <Typography fontSize={"16px"} fontWeight={"medium"}>
         {"Notificações de fim de doação"}
       </Typography>
       <Divider />
       <NotificationListDashboard t={t} />
     </Paper>
      }
     
    </>
  );
};

export default AlertNotification;
